import * as React from "react";

interface Props {
  classPosition: number;
  svgSource: string;
}

const CarouselCard: React.FC<Props> = ({ classPosition, svgSource }) => (
  <div className={`card cd${classPosition}`}>
    <div className="card_content">
      <div className="red">
        <div className="gradient">
          <img src={svgSource} alt="" />
        </div>
      </div>
    </div>
  </div>
);

export default CarouselCard;
